export const useNumberFormatter = (locale: string) => {
  const formatNumber = (value: number) => {
    return new Intl.NumberFormat(locale).format(value);
  };

  return { formatNumber };
};
